var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import Component from 'vue-class-component';
import nemWrapper from '../../../ts/nemWrapper';
import walletModel from '../../../ts/walletModel';
import mosaicTransfer from '../../../ts/mosaicTransfer';
import ConfirmationModal from '../ConfirmationModal.vue';
var ReturnUq = /** @class */ (function (_super) {
    __extends(ReturnUq, _super);
    function ReturnUq() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLoading = false;
        _this.mosaic = new mosaicTransfer();
        _this.toAmount = 0;
        _this.day = "";
        _this.hour = "";
        _this.min = "";
        _this.nday = 0;
        _this.nhour = 0;
        _this.nmin = 0;
        _this.amount_hd = "";
        _this.toAddr = '';
        _this.toMyAddr = "";
        _this.message = '';
        _this.validation = [];
        _this.background_img = './static/img/background.png';
        return _this;
    }
    ReturnUq.prototype.mounted = function () { };
    //modal
    ReturnUq.prototype.openModal = function () {
        this.$data.modal = true;
        this.nday = Number(this.day);
        this.nhour = Number(this.hour);
        this.nmin = Number(this.min);
        this.getAmount_hd(this.nday, this.nhour, this.nmin);
        this.getAmount(this.nday, this.nhour, this.nmin);
    };
    ReturnUq.prototype.closeModal = function () {
        this.$data.modal = false;
        this.$data.info_modal = false;
    };
    ReturnUq.prototype.doSend = function () {
        return __awaiter(this, void 0, void 0, function () {
            var toAmount, massage, nodeUrl, response, timeData, networkTimestamp, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        toAmount = Number(this.getAmount(this.nday, this.nhour, this.nmin));
                        if (!(this.toAmount > 0)) return [3 /*break*/, 7];
                        this.$data.modal = false;
                        massage = '[[[返却]]]';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        nodeUrl = 'https://nem02.neluta.win:7891';
                        return [4 /*yield*/, fetch(nodeUrl + "/time-sync/network-time")];
                    case 2:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error('NEMネットワーク時刻の取得に失敗しました。');
                        }
                        return [4 /*yield*/, response.json()];
                    case 3:
                        timeData = _a.sent();
                        networkTimestamp = timeData.sendTimeStamp;
                        // 3. sendMosaicsを呼び出す際に、7番目の引数として取得した時刻(networkTimestamp)を渡す
                        return [4 /*yield*/, this.mosaic.sendMosaics(this.$data.wallet.privateKey, toAmount, massage, '', // date
                            '', // amount_hd
                            '', // post_message
                            networkTimestamp // ← これが7番目の引数！
                            )];
                    case 4:
                        // 3. sendMosaicsを呼び出す際に、7番目の引数として取得した時刻(networkTimestamp)を渡す
                        _a.sent();
                        // 成功した場合の処理をここに追加できます（例：アラート、ページ遷移など）
                        alert('UQを返却しました。反映までしばらくお待ちください。');
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        console.error('返却処理でエラーが発生しました:', error_1);
                        alert('返却処理に失敗しました。');
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        alert('UQの値が不正です');
                        _a.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    ReturnUq.prototype.getAmount = function (day, hour, min) {
        //8⇨day_uqに置き換える
        var working_hour_per_day = this.mosaic.working_hour_per_day;
        if (this.mosaic.working_hour_per_day == null) {
            this.mosaic.helper.pleaseLogin();
        }
        else {
            var sum_hour = Number(day * this.mosaic.working_hour_per_day) + Number(hour);
            var sum_min = Number(sum_hour * 60) + Number(min);
            var Amount = Math.floor(sum_min * 10 / 6);
            this.toAmount = Amount;
            return Amount;
        }
    };
    //UQ時間換算
    ReturnUq.prototype.getAmount_hd = function (o_day, o_hour, o_min) {
        return __awaiter(this, void 0, void 0, function () {
            var working_hour_per_day, min, hour, day;
            return __generator(this, function (_a) {
                //8⇨day_uqに置き換える
                if (this.mosaic.working_hour_per_day == null) {
                    this.mosaic.helper.pleaseLogin();
                }
                else {
                    working_hour_per_day = this.mosaic.working_hour_per_day;
                    this.amount_hd = "";
                    min = o_min % 60;
                    o_hour = Number(Math.floor(o_min / 60) + Number(o_hour));
                    hour = o_hour % working_hour_per_day;
                    day = Number(Math.floor(o_hour / working_hour_per_day)) + Number(o_day);
                    if (day !== 0) {
                        this.amount_hd = this.amount_hd + String(day) + "日 ";
                        if (hour !== 0) {
                            this.amount_hd = this.amount_hd + "と " + String(hour) + "時間 ";
                        }
                        else if (min !== 0) {
                            this.amount_hd = this.amount_hd + "と";
                        }
                    }
                    else {
                        if (hour !== 0) {
                            this.amount_hd = this.amount_hd + String(hour) + "時間 ";
                        }
                    }
                    if (min !== 0) {
                        this.amount_hd = this.amount_hd + String(min) + "分";
                    }
                    console.log(day + "   " + hour + "   " + min);
                }
                return [2 /*return*/];
            });
        });
    };
    ReturnUq.prototype.getAccount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = true;
                        return [4 /*yield*/, this.$data.wallet.getAccount()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.$data.wallet.getUnconfirmed()];
                    case 2:
                        _a.sent();
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ReturnUq.prototype.tapSend = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('tapSend');
                        if (!(this.isValidation() === true)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$data.wallet.sendNem(this.toAddr, this.toAmount, this.message)];
                    case 1:
                        result = _a.sent();
                        console.log('tapSend', result);
                        message = '送金しました';
                        if (result.message !== 'SUCCESS') {
                            message = "Error " + result.message;
                        }
                        Vue.prototype.$toast(message);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ReturnUq.prototype.isValidation = function () {
        this.validation = [];
        this.validation.push(this.$data.rules.senderAddrLimit(this.toAddr));
        this.validation.push(this.$data.rules.senderAddrInput(this.toAddr));
        this.validation.push(this.$data.rules.amountLimit(this.toAmount));
        this.validation.push(this.$data.rules.amountInput(this.toAmount));
        this.validation.push(this.$data.rules.messageRules(this.message));
        console.log(this.validation);
        var isError = false;
        this.validation.forEach(function (obj) {
            if (obj !== true) {
                isError = true;
            }
        });
        return !isError;
    };
    ReturnUq.prototype.setData = function (address, privateKey) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.$data.wallet.setData(address, privateKey);
                return [2 /*return*/];
            });
        });
    };
    ReturnUq = __decorate([
        Component({
            name: 'return',
            data: function () { return ({
                nem: new nemWrapper(),
                mosaic: new mosaicTransfer(),
                wallet: new walletModel(),
                modal: false,
                qrJson: '',
                fmessage: 'father message',
                rules: {
                    senderAddrLimit: function (value) { return (value && (value.length === 46 || value.length === 40)) || '送金先アドレス(-除く)は40文字です。'; },
                    senderAddrInput: function (value) {
                        var pattern = /^[a-zA-Z0-9-]+$/;
                        return pattern.test(value) || '送金先の入力が不正です';
                    },
                    amountLimit: function (value) { return (value >= 0) || '数量を入力してください'; },
                    amountInput: function (value) {
                        var pattern = /^[0-9.]+$/;
                        return (pattern.test(value) && !isNaN(Number(value))) || '数量の入力が不正です';
                    },
                    messageRules: function (value) { return (value.length <= 1024) || 'メッセージの最大文字数が超えています。'; }
                },
            }); },
            watch: {
                'wallet.address': function (newVal, oldVal) {
                    this.$data.qrJson = this.$data.nem.getQRcodeJson('2', 2, '', newVal, 0, '');
                }
            },
            components: { ConfirmationModal: ConfirmationModal },
            methods: {
                myactionFunc: function () {
                },
                func: function (msg) {
                    console.log(msg);
                },
            },
            props: ['version']
        })
    ], ReturnUq);
    return ReturnUq;
}(Vue));
export default ReturnUq;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/details/ReturnUq.vue
// module id = 273
// module chunks = 1